document.addEventListener("DOMContentLoaded", (event) => {

  if (window.innerWidth > 1024) {
    const discoverMoreButton = document.querySelector('.hero-banner__discover-more');
    const parentSection = discoverMoreButton.closest("section.shopify-section");
    const nextSiblingOfParentSection = parentSection.nextElementSibling;
    const headerHeight = 49;

    if (nextSiblingOfParentSection) {

      discoverMoreButton.addEventListener('click', () => {

        const nextSiblingOfParentSectionTopOffset = nextSiblingOfParentSection.getBoundingClientRect().top;

        window.scrollTo({
          top: (nextSiblingOfParentSectionTopOffset + window.scrollY) - headerHeight,
          behavior: 'smooth'
        });
      });
    }
  }
});